export default "__VITE_ASSET__tsA7SU23GiWUWhsypuHniQ__"